import React from 'react';
import type { SxProps, Theme } from '@mui/material';

import type { CalendarSessionCue } from '../utils/sessionCue';

interface CalendarSessionCueIconProps {
  cue: CalendarSessionCue;
  sx?: SxProps<Theme>;
}

/**
 * Calendar grids can render dozens of session cues at once. Keep their hover
 * label on the SVG itself instead of wrapping every icon in MUI Tooltip, whose
 * stateful composed ref can schedule updates while React 19 tears down a route.
 */
export const CalendarSessionCueIcon = ({ cue, sx }: CalendarSessionCueIconProps) => {
  const Icon = cue.Icon;

  return <Icon aria-label={cue.label} titleAccess={cue.label} sx={sx} />;
};
